"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHasuraBackendPlus = exports.Instance = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const nhost_js_sdk_1 = __importDefault(require("nhost-js-sdk"));
const vue_demi_1 = require("vue-demi");
const inject_key_1 = require("./inject-key");
class Instance {
    constructor(options) {
        var _a;
        nhost_js_sdk_1.default.initializeApp({
            base_url: options.endpoint,
            refresh_interval_time: (options.refreshInSeconds || 600) * 1000
        });
        this.auth = nhost_js_sdk_1.default.auth();
        this.storage = nhost_js_sdk_1.default.storage();
        this.claims = vue_demi_1.ref();
        this.authenticated = vue_demi_1.ref(false);
        this.token = vue_demi_1.ref();
        (_a = options.router) === null || _a === void 0 ? void 0 : _a.beforeEach((to, from, next) => __awaiter(this, void 0, void 0, function* () {
            if (this.auth.isAuthenticated() === null) {
                this.authenticated.value = yield new Promise(resolve => {
                    this.auth.onAuthStateChanged((status) => {
                        resolve(status);
                    });
                });
            }
            next();
        }));
        this.auth.onAuthStateChanged((logged_in) => {
            this.authenticated.value = logged_in;
            if (logged_in) {
                const token = this.auth.getJWTToken();
                this.token.value = token;
                this.claims.value = jwt_decode_1.default(token)['https://hasura.io/jwt/claims'];
            }
            else {
                this.token.value = undefined;
                this.claims.value = undefined;
            }
        });
    }
    install(app, injectKey) {
        app.provide(injectKey || inject_key_1.DefaultHasuraBackendPlusKey, this);
    }
}
exports.Instance = Instance;
const createHasuraBackendPlus = (options) => {
    return new Instance(options);
};
exports.createHasuraBackendPlus = createHasuraBackendPlus;
//# sourceMappingURL=instance.js.map